import { render, staticRenderFns } from "./AnswerPaper.vue?vue&type=template&id=7ae144ca"
import script from "./AnswerPaper.vue?vue&type=script&lang=js"
export * from "./AnswerPaper.vue?vue&type=script&lang=js"
import style0 from "./AnswerPaper.vue?vue&type=style&index=0&id=7ae144ca&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports